//interfaces
import { IRadioButtonItem, IRadioButtonItems } from "@/interfaces/radioButtonList";

//styling
import "../../../../../css/global/lists/radioButtonList.scss";



const RadioButtonList= ({buttons} : IRadioButtonItems) => {   

    return (
      <div className="radio-button-list">
          {buttons.map((button: IRadioButtonItem, index: number) => (
              <span key={`radio-button-${index}`}className={`radio-button-list-item ${button.isChecked && "checked-item"}`}>
                  <input id={`radio-button-${index}`}  className="radio-button-input" onChange={button.onClick} type="radio" checked={button.isChecked}/>
    
                  <label htmlFor={`radio-button-${index}`} className="content">{button.content}</label>
              </span>
          ))}
      </div>
    );
}
  
export default RadioButtonList